<template lang="pug">
  div.faq(v-if="faqShow")
    van-search(class="faq_search", v-model="search", show-action, :placeholder="this.$t('searchInput')", @search="onSearch")
      template(#action)
        div(@click="onSearch") {{$t('search')}}
    div.faq_content
      van-collapse(v-model="activeName", accordion)
        van-collapse-item(v-for="(item, key) in faqQuick", :key='key', :title="item.title", v-if="item.content.length > 0")
          van-cell(class="faq_cell", v-for="(i, k) in item.content", :key="k", :title="i.title", is-link, :id="i.id", @click='toContentPage(i)')
      van-button(type="danger", class="faq_hist_btn", round, @click="toHistoryPage") {{$t('hisConverse')}}
          div(v-if="badge").van-info {{badge}}
      div.corner(v-if="showCorner==='true'", @click="toSubmitPage")
    //- p.faq_tip 没有解决问题？
    //- p.faq_fb 联系客服人员（Facebook）
  //- <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  //- </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Faq',
  data(){
    return {
      search: '',
      activeName: -1,
      faqQuick: [],
      badge: 0,
      showCorner: 'false',
      faqShow: false
    }
  },
  created(){
  },
  methods:{
    ...mapActions(['getSwitchInfo']),
    ...mapActions('faq', ['getCategoryList', 'getFAQContentList', 'getNewMsgNo', 'searchFaq', 'getFaqVersion']),
    toContentPage(val){
        this.$router.push({
            path: '/faq/content',
            query: {
                id: val.id,
                type: val.type
            }
        })
    },
    toSubmitPage(){
      // if(this.$route.query.status === '1'){
      //   this.$router.push({
      //     path: '/faq/report',
      //     query: this.content
      //   })
      // } else {
        this.$router.push({
          path: '/faq/submit',
          query: this.content
        })
      // }
    },
    getCookiesObj() { 
      return document.cookie.split(';').reduce((f, sv) => {
          let _sv = sv.trim().split('=').map(v => {
              return v.trim()
          })
          f[_sv[0]] = _sv[1]   
          return f  
      }, {})
    },
    toHistoryPage(){
        this.$router.push({
            path: '/faq/history'
        })
    },
    onSearch(){
        this.$router.push({
            path: '/faq/searchResult',
            query: {
              search: this.search
            }
        })
      // this.searchFaq({
      //   uid: this.uid,
      //   deviceId: this.deviceId,
      //   accessToken: this.token,
      //   appId: this.appid,
      //   channelId: this.channelId,
      //   content: this.search,
      //   languageCode: this.lang
      // })
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'appid', 'channelId', 'switchInfo', 'switching', 'lang', 'phoneModel']),
    ...mapGetters('faq', ['errmsg', 'loadingCate', 'categoryList', 'loadingFC', 'faqContentList', 'loadingNO', 'msgNo', 'searchData', 'searching', 'faqVersion', 'fvLoading'])
  },
  mounted(){
    if(this.faqContentList && this.faqContentList.faqContentList && this.faqContentList.faqContentList.length > 0){
      this.faqQuick = this.categoryList.faqCategoryList.map(val => {
        val.content = new Array();
        return val
      })
      this.faqContentList.faqContentList.map(val => {
        this.faqQuick = this.faqQuick.map(v => {
          if(val.faqCategory == v.id){
            // console.log(val, v)
            v.content.push(val);
          }
          return v
        })
      })
    } else {
      // window.webkit.messageHandlers.showToastForJS.postMessage(this.uid)
      // window.webkit.messageHandlers.showToastForJS.postMessage(this.token)
      // window.webkit.messageHandlers.showToastForJS.postMessage(this.deviceId)
      if(this.uid && this.token && this.deviceId){
        this.getCategoryList(Qs.stringify({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          appId: this.appid,
          channelId: this.channelId,
          phoneModel: this.phoneModel,
          languageCode: this.lang
        }))
      }
    }
    if(this.uid && this.token && this.deviceId){
      this.getNewMsgNo(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        phoneModel: this.phoneModel,
        accessToken: this.token
      }))
      this.getSwitchInfo({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        phoneModel: this.phoneModel,
        channelId: this.channelId,
        switchId: '11,12,13,22,26,28'
      })
      this.getFaqVersion({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
      })
    }
    if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[12]){
      this.showCorner = this.switchInfo.switchInfoList[12]
    }
    this.$watch('deviceId', val => {
      this.$store.commit('INIT', {
        uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
        cpUid: this.getCookiesObj() && this.getCookiesObj()['cpUid'] || '',
        token: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
      })
      // window.webkit.messageHandlers.showToastForJS.postMessage(111)
      this.getCategoryList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        phoneModel: this.phoneModel,
        languageCode: this.lang
      }))
      this.getNewMsgNo(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        phoneModel: this.phoneModel,
        accessToken: this.token
      }))
      this.getSwitchInfo({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        phoneModel: this.phoneModel,
        channelId: this.channelId,
        switchId: '11,12,13,22,26,28'
      })
      this.getFaqVersion({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
      })
    })
    this.$watch('fvLoading', val => {
      if(val === 'loaded'){
        console.log(this.faqVersion.extVal)
        if(this.faqVersion.extVal && this.faqVersion.extVal == 'v2'){
          window.location.href = CONFIG.v2faqUrl + '/faq/1'
        } else {
          this.faqShow = true
        }
      }
    })
    this.$watch('searching', val => {
      if(val === 'searched'){
        // console.log(this.searchData);
      }
    })
    this.$watch('loadingCate', (val, oldval) => {
      // console.log(val, oldval)
      if(val === 'loadedCate'){
        this.faqQuick = this.categoryList.faqCategoryList.map(val => {
          val.content = new Array();
          return val
        })
        this.getFAQContentList(Qs.stringify({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          channelId: this.channelId,
          phoneModel: this.phoneModel,
          languageCode: this.lang
        }))
        // console.log(this.categoryList.faqCategoryList)
      }
    })
    this.$watch('loadingFC', val => {
      if(val === 'loadedFC'){
        // let a = [];
        this.faqContentList.faqContentList.map(val => {
          this.faqQuick = this.faqQuick.map(v => {
            if(val.faqCategory == v.id){
              v.content.push(val);
            }
            return v
          })
        })
      }
    })
    this.$watch('loadingNO', val => {
      if(val === 'loadedNo'){
        this.badge = this.msgNo.newMessageNumber || null;
      }
    })
    this.$watch('switchInfo', val => {
      if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[12]){
        this.showCorner = this.switchInfo.switchInfoList[12]
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.faq_content{
  margin: 10px;
  .van-collapse {
    margin-bottom: 10px;
  }
}
.faq_search{
  margin-top: -20px;
}
.faq_cell{
  .van-cell__right-icon::before{
    content: '';
  }
}
.faq_tip{
  font-size: 12px;
  color: #000;
  text-align: center;
  margin-top: 32px;
  font-weight: 300;
  margin-bottom: 1px;
}
.faq_fb{
  font-size: 12px;
  color: #e60012;
  text-align: center;
  text-decoration:underline
}
.faq_hist_btn{
  width: 90%;
  left: 5%;
  padding: 15px;
}
</style>